

const mapDOM = document.querySelector('#map');

if (mapDOM) {
  window.mapboxgl.accessToken = 'pk.eyJ1Ijoid2ViLWlkZWEiLCJhIjoiY2t4NGo0OXB6MTY4dDJ1dXFxbzczZmp6NiJ9.KpzE7WQEVkf28s5JmI2KiQ';
  const coordinates = [6.176965578517397, 49.11432160140992];
  const map = new window.mapboxgl.Map({
    container: 'map', // container ID
    style: 'mapbox://styles/mapbox/streets-v11', // style URL
    center: coordinates, // starting position [lng, lat]
    zoom: 14 // starting zoom
  });

  new window.mapboxgl.Marker({
    color: '#3FB1CE',
    draggable: false
  }).setLngLat(coordinates)
    .addTo(map);

}




// WEBPACK FOOTER //
// ./scripts/modules/map.js